import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CcsSkeletonComponent } from '@shared/components';
import { getStateCourt } from '@shared/utils';

@Component({
  selector: 'app-toolbar-avatar',
  imports: [CcsSkeletonComponent],
  templateUrl: './toolbar-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarAvatarComponent {
  protected readonly court = getStateCourt();
  protected clerkPhotoLoaded = false;
}
